import { useGetVisaDocumentTransactionList } from 'api-hooks/visa-document';
import { KIND, Notification } from 'baseui/notification';
import Separator from 'components/common/separator';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { FullContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import React from 'react';

import VisaDocumentTransactionListItem from './visa-document-transaction-list-item';

export default function VisaDocumentTransactionList() {
  const { query, isReady } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, refetch } = useGetVisaDocumentTransactionList(
    {
      id,
    },
    {
      enabled: isReady,
    },
  );

  const isEmpty = !data?.data?.length;

  const items = data?.data || [];

  return (
    <FetchWrapperComponent
      error={error}
      isLoading={isLoading}
      onRetry={refetch}
      showEmptyComponent={isEmpty}
      component={
        <FullContainer
          style={{
            overflow: 'auto',
            maxHeight: 'calc(100dvh - 250px)',
          }}
        >
          {!!error && !!error.message && (
            <div>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </div>
          )}
          {items.map((item, index) => {
            return (
              <>
                <VisaDocumentTransactionListItem
                  key={JSON.stringify(item)}
                  data={item}
                />
                <Separator gap={48} />
              </>
            );
          })}
        </FullContainer>
      }
    />
  );
}
